import {
  getPlansRequest,
  getBillingRequest,
  getSourceSettingsRequest,
  getWarehouseSettingsRequest,
  getMTUsForPast30Days
} from 'selectors'

export function getMigrationDataLoading (state, workspaceSlug) {
  const plans = getPlansRequest(state)
  const billing = getBillingRequest(state, workspaceSlug)
  const sources = getSourceSettingsRequest(state, workspaceSlug)
  const warehouses = getWarehouseSettingsRequest(state, workspaceSlug)
  const mtus = getMTUsForPast30Days(state, workspaceSlug)
  const isLoading = (
    getLoading(plans, 'didRequest') || getLoading(billing, 'hasRequested') || getLoading(sources) || getLoading(warehouses) || getLoading(mtus)
  )

  return isLoading
}

function getLoading (state, hasRequestedKey) {
  return (hasRequestedKey && !state[hasRequestedKey]) || state.isRequesting
}



// WEBPACK FOOTER //
// ./selectors/migration-data-loading.js